import { render, staticRenderFns } from "../template/template.html?vue&type=template&id=1fd556de&scoped=true&external"
import script from "../template/template.js?vue&type=script&lang=js&external"
export * from "../template/template.js?vue&type=script&lang=js&external"
import style0 from "../template/template.css?vue&type=style&index=0&id=1fd556de&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd556de",
  null
  
)

export default component.exports